export function humanize(camelized){
  return `${camelized}`.split(/(?=[A-Z])|_/).map(s => s[0]?.toUpperCase() + s.slice(1)).join(" ");
}

export function capitalize(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export function titleize(string){
  if (!string) {
    return string;
  }
  return humanize(string).split(' ').map(word => word.length > 0 ? capitalize(word) : '').join(' ')
}

export function pluralize(string, n, includeN=false){
  return `${includeN ? n + ' ' : ''}${string}${n !== 1 ? 's' : ''}`
}

export function parameterize(string, separator){
  return string.toLowerCase().replace(' ', separator || '_')
}

export function chopString(s, max) {
  return s.length > max ? s.slice(0, max).concat('...') : s
}

export function uuid() {
  let bits = (window.crypto || window.msCrypto).getRandomValues(new Uint8Array(16))
  bits[8] = (bits[8] & 0x3F) | 0x80
  bits[6] = (bits[6] & 0x0F) | 0x40
  let i = 0
  return ([1e7]+-1e3+-1e3+-1e3+-1e11).replace(/[018][018]/g, d => {
    let x = bits[i++].toString(16)
    if(x.length === 1) {
      x = '0' + x
    }
    return x
  })
}